<div class="p-4 md:p-6 lg:p-8 max-w-7xl mx-auto space-y-6">
  <!-- Header / Navigation -->
  <div class="flex items-center gap-4">
    @if (canGoBack()) {
      <button matIconButton (click)="goBack()" aria-label="現場一覧へ戻る">
        <mat-icon>arrow_back</mat-icon>
      </button>
    }
    <h1 class="text-2xl font-bold text-gray-800 m-0">現場詳細</h1>
  </div>

  @if (siteDetail()) {
    @let detail = siteDetail()!;
    <mat-tab-group animationDuration="0ms" class="bg-transparent">
      <mat-tab label="基本情報">
        <div class="pt-6">
          <app-site-dashboard 
            [siteId]="detail.id" 
            [showHeader]="false"
            containerClass="space-y-6"
          ></app-site-dashboard>
        </div>
      </mat-tab>

      <!-- Sensor Management Section -->
      <mat-tab label="センサー管理">
        <div class="pt-6">
          <app-site-sensor-manage [id]="detail.id"></app-site-sensor-manage>
        </div>
      </mat-tab>

      <!-- Drawing Management Section -->
      <mat-tab label="図面管理">
        <div class="pt-6 min-h-[600px] max-h-[80vh]">
          <app-site-drawing-manage [siteId]="detail.id"></app-site-drawing-manage>
        </div>
      </mat-tab>

    </mat-tab-group>
  } @else {
    <!-- Empty state or loading -->
    <div class="flex flex-col items-center justify-center h-64 bg-white rounded-xl shadow-sm border border-gray-100 text-gray-500">
      <mat-icon class="text-4xl mb-4 text-gray-300">hourglass_empty</mat-icon>
      <p class="text-lg">現場データを読み込んでいます...</p>
      <p class="text-sm text-gray-400 mt-2">データが存在しないか、アクセス権がありません。</p>
    </div>
  }
</div>
